import { getNetlifyFunctionsBase } from "./netlifyFunctions.js";
import {
  getStoredReflections,
  setStoredReflections,
  clearAnonymousReflections
} from "./reflectionStorage.js";

function buildCombinedEntry(item) {
  return [item.event, item.interpretation, item.evidence, item.response]
    .map((s) => String(s || "").trim())
    .filter(Boolean)
    .join("\n\n");
}

/**
 * Upload pending anonymous (pre-login) local reflections on login (oldest first).
 * Remaining drafts are moved under the signed-in user id key.
 * @returns {{ synced: number, capped: boolean }}
 */
export async function syncAllLocalReflectionsOnLogin(email, userId) {
  const stored = await getStoredReflections(); // anonymous + legacy only
  if (!stored.length) return { synced: 0, capped: false };

  const toSync = [...stored].reverse();
  const stillLocal = [];
  let synced = 0;
  let capped = false;

  for (let i = 0; i < toSync.length; i += 1) {
    const item = toSync[i];
    const combinedEntry = buildCombinedEntry(item);
    if (!combinedEntry.trim()) continue;

    try {
      const response = await fetch(`${getNetlifyFunctionsBase()}/.netlify/functions/getPersonalizedInsights`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          entry: combinedEntry,
          userResponse: item.response || "",
          email,
          mode: "deep_reflection"
        })
      });

      if (response.status === 402) {
        capped = true;
        stillLocal.push(...toSync.slice(i));
        break;
      }

      if (!response.ok) {
        stillLocal.push(item);
        continue;
      }

      synced += 1;
    } catch (err) {
      console.error("Unable to sync local reflection on login.", err);
      stillLocal.push(item);
    }
  }

  await clearAnonymousReflections();
  if (stillLocal.length > 0 && userId) {
    const existing = await getStoredReflections(userId);
    await setStoredReflections([...stillLocal.reverse(), ...existing], userId);
  } else if (stillLocal.length > 0) {
    await setStoredReflections(stillLocal.reverse());
  }

  return { synced, capped };
}
